import React, { Component } from 'react';
import ActionModal, { ActionModalFooter } from 'common-components/modal/ActionModal';
import { notification } from 'antd';
import { Paragraph } from 'common-components/typography';
import { GhostButton, PrimaryButton } from 'common-components/buttons';

interface UnchargeGroupBookingCancellationFeeModalProps {
  isOpen: any;
  onClose: any;
  booking: any;
  doUnchargeGroupBookingsCancellationFee: any;
}
interface UnchargeGroupBookingCancellationFeeModalState {
  step: number;
  canManuallyClose: boolean;
  title: string;
  startDateTime: Date;
  isLoading: boolean;
}

export class UnchargeGroupBookingCancellationFeeModal extends Component<
  UnchargeGroupBookingCancellationFeeModalProps,
  UnchargeGroupBookingCancellationFeeModalState
> {
  state = { step: 1, canManuallyClose: true, title: '', startDateTime: null, isLoading: false };

  renderView = () => {
    const { step } = this.state;
    const { booking } = this.props;
    const { billingTotal } = booking;
    if (step === 1) {
      return (
        <div className="anim-fade-in">
          <Paragraph>Are you sure you want to remove the cancellation fee for this booking?</Paragraph>
          <ActionModalFooter>
            <GhostButton className="mr-medium" size="large" onClick={this.onCloseModal} disabled={this.state.isLoading}>
              Cancel
            </GhostButton>
            <PrimaryButton size="large" icon="check" onClick={this.onAccept} disabled={this.state.isLoading}>
              Remove cancellation fee
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }

    if (step === 2) {
      return (
        <div className="anim-slide-right">
          <Paragraph>You have successfully removed the cancellation fee for this booking.</Paragraph>

          <ActionModalFooter>
            <PrimaryButton size="large" onClick={this.onCloseModal}>
              Close
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      const { booking } = this.props;
      this.setState({ step: 1, title: 'Remove cancellation fee' });
    }
  }

  onAccept = async () => {
    const { booking } = this.props;
    try {
      this.setState({ canManuallyClose: false, isLoading: true });
      await this.props.doUnchargeGroupBookingsCancellationFee({
        serviceId: booking.serviceId,
        serviceDateTimeId: booking.serviceDateTimeId,
        bookingIds: [booking.bookingId],
      });
      this.setState({ step: 2, canManuallyClose: true, title: 'Cancellation fee removed', isLoading: false });
    } catch (e) {
      this.setState({ canManuallyClose: true, isLoading: false });
      notification.error({ message: 'Oops, something went wrong, please try again.' });
    }
  };

  onCloseModal = () => {
    const { onClose } = this.props;
    this.setState({ step: 1, canManuallyClose: true, title: '' }, onClose);
  };

  render() {
    let { isOpen } = this.props;
    const { title } = this.state;
    return (
      <ActionModal
        isOpen={isOpen}
        title={title}
        width="medium"
        onClose={this.onCloseModal}
        canCloseOutside={this.state.canManuallyClose}
        showCloseButton={this.state.canManuallyClose}
        verticalAlignment="highest"
      >
        <div>{this.renderView()}</div>
      </ActionModal>
    );
  }
}
